import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { apiGet } from '../../generic/Api_Functions'

const PartPresetHistory = ({ part, preset }) => {
  const { t_ } = useSmartTranslation()
  const addPositiveSymbol = (value) => {
    return value > 0 ? '+' + value : value
  }

  const variables = ['x', 'y', 'z', 'a', 'b', 'c']

  const presetDataFetch = async (pagination) => {
    const data = await apiGet('fixturePartPreset/' + preset.part.id + '/' + preset.fixture.id, pagination)
    data.content.forEach((row) => {
      variables.forEach((variable) => {
        row[variable + '_Offset'] = addPositiveSymbol(row[variable + '_Offset'])
      })
    })
    return data
  }

  let presetColumns = variables.flatMap((variable) => {
    return [
      {
        name: t_(variable.toUpperCase() + ' Nominal'),
        field: variable + '_Nominal',
        readOnly: true,
        numeric: true
      },
      {
        name: t_(variable.toUpperCase() + ' Offset'),
        field: variable + '_Offset',
        readOnly: true,
        mandatory: true
      }
    ]
  })

  presetColumns = [...presetColumns,

    {
      name: t_('Registered date'),
      field: 'registeredDate',
      type: 'dateTimePicker',
      readOnly: true
    }
  ]

  return (
    <>
      <SmartMateriaUITable
        title={
          <div style={{ textAlign: 'left' }}>
            {t_('Part: ') + preset.part.code}
            <br />
            {t_('Fixture: ') + preset.fixture.code}
          </div>
        }
        columns={presetColumns}
        dataFetch={presetDataFetch}
        pageable
      />
    </>
  )
}

export default PartPresetHistory
